// extracted by mini-css-extract-plugin
export default {"container":"bP-z","topReviewHeading":"cP-z","criticalReview":"dP-z","favorableReview":"eP-z","vsSeparator":"fP-z"};